import React from 'react';
import LazyComponent from '../components/common/LazyComponent';
import StripeProvider from '../components/payment/StripeProvider';

// Lazily load components
const Place = React.lazy(() => import('../components/Place'));
const PaymentStatus = React.lazy(() => import('../components/payment/stripe/PaymentStatus'));

interface PaymentSuccessViewProps {
  orderId: string | number;
}

/**
 * View component for payment success page
 */
const PaymentSuccessView: React.FC<PaymentSuccessViewProps> = ({ orderId }) => {
  return (
    <div className="container mt-5">
      <LazyComponent>
        <Place oID={String(orderId || 0)} />
      </LazyComponent>
      
      <StripeProvider>
        <LazyComponent>
          <PaymentStatus />
        </LazyComponent>
      </StripeProvider>
    </div>
  );
};

export default PaymentSuccessView; 